import { invariant } from '@/shared/utils/typeAssertions'
import { inject, provide, type InjectionKey, type Ref } from 'vue'

type CaseContext = {
  caseId: Ref<string>
  workspaceId: Ref<string>
}

export const CASE_CONTEXT_KEY: InjectionKey<CaseContext> = Symbol('case')

export const provideCaseContext = (caseId: Ref<string>, workspaceId: Ref<string>) => {
  provide(CASE_CONTEXT_KEY, { caseId, workspaceId })
}

/** Provides id data for the Case in the current component hierarchy. */
export const useCaseContext = () => {
  const caseContext = inject(CASE_CONTEXT_KEY)
  invariant(caseContext, 'Case context was not provided')
  return caseContext
}
